import { PhotoColor } from '../types/__generated__/globalTypes';

export const photoColors: Array<PhotoColor> = [
  PhotoColor.color,
  PhotoColor.bw,
  PhotoColor.sepia,
];
